import { absUrl } from "../lib/media";
import React from "react";
import { MessageCircle } from "lucide-react";

const L = {
  pt: { ingredients: "Ingredientes", steps: "Modo de preparo", min: "min", guests: "convidados", cost: "Custo estimado", footer: "Planejado com MY CHRISTMAS", share: "Enviar por WhatsApp" },
  "pt-PT": { ingredients: "Ingredientes", steps: "Modo de preparação", min: "min", guests: "convidados", cost: "Custo estimado", footer: "Planeado com MY CHRISTMAS", share: "Enviar por WhatsApp" },
  en: { ingredients: "Ingredients", steps: "Preparation", min: "min", guests: "servings", cost: "Estimated cost", footer: "Planned with MY CHRISTMAS", share: "Share on WhatsApp" },
  es: { ingredients: "Ingredientes", steps: "Preparación", min: "min", guests: "invitados", cost: "Costo estimado", footer: "Planificado con MY CHRISTMAS", share: "Enviar por WhatsApp" },
  fr: { ingredients: "Ingrédients", steps: "Préparation", min: "min", guests: "convives", cost: "Coût estimé", footer: "Planifié avec MY CHRISTMAS", share: "Envoyer sur WhatsApp" },
  it: { ingredients: "Ingredienti", steps: "Preparazione", min: "min", guests: "ospiti", cost: "Costo stimato", footer: "Pianificato con MY CHRISTMAS", share: "Invia su WhatsApp" },
};

export const recipeToWhatsAppText = (r, lang = "pt", price = null, withImage = true) => {
  const T = L[lang] || L.pt;
  const lines = [`🎄 *${r.name}*`];
  if (withImage && r.image) lines.push(absUrl(r.image));
  if (r.description) lines.push(r.description);
  const meta = [r.time_minutes ? `⏱ ${r.time_minutes} ${T.min}` : null, r.servings ? `👥 ${r.servings} ${T.guests}` : null, price ? `💰 ${T.cost}: ${price}` : null].filter(Boolean);
  if (meta.length) lines.push(meta.join(" · "));
  lines.push("", `*${T.ingredients}*`, ...(r.ingredients || []).map((i) => `• ${i}`));
  lines.push("", `*${T.steps}*`, ...(r.steps || []).map((s, i) => `${i + 1}. ${s}`));
  lines.push("", `_${T.footer}_`);
  return lines.join("\n");
};

export const openWhatsApp = (text) => window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && window.innerWidth < 1024);

// Mobile: share the photo as an attachment (Web Share API) with the recipe text as caption.
// Desktop / unsupported: wa.me text with the image link on top (WhatsApp renders it as preview).
export const shareRecipe = async (recipe, lang, price) => {
  const text = recipeToWhatsAppText(recipe, lang, price, true);
  if (!(recipe.image && isMobile() && navigator.share && navigator.canShare)) return openWhatsApp(text);
  try {
    const res = await fetch(absUrl(recipe.image), { mode: "cors" });
    const blob = await res.blob();
    const file = new File([blob], `${(recipe.id || "recipe")}.jpg`, { type: blob.type || "image/jpeg" });
    if (navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: recipe.name, text: recipeToWhatsAppText(recipe, lang, price, false) });
      return;
    }
  } catch (e) {
    if (e?.name === "AbortError") return; // user cancelled the share sheet
  }
  // after an await, window.open may be popup-blocked → navigate instead
  window.location.href = `https://wa.me/?text=${encodeURIComponent(text)}`;
};

export const WhatsAppShareButton = ({ recipe, lang, price, testid = "recipe-share-whatsapp", className = "" }) => {
  const T = L[lang] || L.pt;
  return (
    <button type="button" onClick={() => shareRecipe(recipe, lang, price)} data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full border border-[#25D366]/50 bg-[#25D366]/10 px-5 py-2.5 text-xs font-semibold text-[#25D366] transition hover:bg-[#25D366]/20 ${className}`}>
      <MessageCircle className="h-4 w-4" /> {T.share}
    </button>
  );
};
